import styled from 'styled-components'
import { SampleDataForm } from '../../calls/components/SampleData/SampleDataForm'

export const SettingsSampleData = () => {
  return (
    <Div>
      <div className="sample-data-header">
        <h2>Sample Data</h2>
        <p>Create or edit sample data for use when working on File Center Settings.</p>
      </div>
      <SampleDataForm />
    </Div>
  )
}

const Div = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .sample-data-header {
    margin-bottom: 1rem;
  }
`
